import { Component, OnInit } from '@angular/core';
import { RequestService } from 'src/app/onelog/services/request.service';
import { MAX_SIZE } from 'src/app/onelog/common/config/common';
import { SOURCE_DERIVATIVE_PRODUCT_RELATION } from 'src/app/onelog/common/config/url';

@Component({
  selector: 'app-source-derivative-product',
  templateUrl: './source-derivative-product.component.html',
  styleUrls: ['./source-derivative-product.component.css']
})
export class SourceDerivativeProductComponent implements OnInit{

  products: any = [];
  totalProducts: number = 0;
  perPage: number = 0;
  lastPage: number = 0;
  currentPage: number = 1;
  showSearchLoading: boolean = false;
  pageSize: number = 25;
  maxSize: number = MAX_SIZE;
  searchBtnText: string = 'Search';
  responseData: any = [];

  constructor(
    private _requestService: RequestService
  ) {}
  
  ngOnInit(): void {
  
    this.loadProducts(this.createPostData());
  }

  loadProducts(
    postData: any = [],
    url: string = SOURCE_DERIVATIVE_PRODUCT_RELATION
  ) {
     return this._requestService
       .postRequest(url, postData)
       .subscribe((data: {}) => {
         this.responseData = data;
         this.products = data;
         if (this.products.length > 0) {
           this.totalProducts = (
             data as { total_count: number }[]
           )[0].total_count;
         }
         this.perPage = 25;
         this.lastPage = Math.floor(this.totalProducts / 25) + 1;
         console.log(this.products);
         this.searchBtnText = 'Search';
         this.showSearchLoading = false;
       });
   } 

  createPostData() {
    return {
      page: this.currentPage
    };
  }

  downloadReport() {
      this._requestService.download(
        SOURCE_DERIVATIVE_PRODUCT_RELATION,
        {
          is_download: 1,
          page: this.currentPage
        },
        '',
        'source_derivative_products_rel'
      );
  }

  updatePageData(event: Event) {
    let eventData: any = event;
    let urlParams = '?page=' + eventData.currentPage;
    this.currentPage = eventData.currentPage;
    //console.log(eventData, urlParams);
    this.loadProducts(this.createPostData());
  }

}
